import { useEffect, useState } from 'react'
import EmailIcon from '../assets/icons/email.svg'
import PhoneIcon from '../assets/icons/phone.svg'
import { useWallet } from '../context/WalletContext'

export default function UserInfoComponent({ profile }) {
    const { updateProfile, isConnected } = useWallet();
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [editing, setEditing] = useState(null);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        setEmail(profile?.email || '');
        setPhone(profile?.phone || '');
    }, [profile]);

    const save = async (field) => {
        if (!isConnected) return;
        setSaving(true);
        setMessage('');
        try {
            await updateProfile(field === 'email' ? { email } : { phone });
            setEditing(null);
            setMessage('Saved');
        } catch (err) {
            setMessage(err.message);
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="flex bg-bg sm:flex-row flex-col rounded-[16px] sm:min-w-[550px] px-[40px] py-[35px] justify-between gap-[40px]">
            <div className="flex flex-col">
                <p className="text-white text-[28px] font-semibold">E-mail</p>
                {editing === 'email' ? (
                    <input
                        className="mt-2 bg-[#141414] border border-[#2C2C2C] rounded-lg text-white px-3 py-2"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                ) : (
                    <p className="text-gray1 text-[18px] font-normal">{email || '—'}</p>
                )}
                <button
                    className="flex px-[15px] w-[180px] py-[10px] mt-8 justify-center items-center gap-1 bg-primary rounded-[56px]"
                    onClick={() => editing === 'email' ? save('email') : setEditing('email')}
                    disabled={!isConnected || saving}
                >
                    <img src={EmailIcon} alt='ico' />
                    <p className="text-black text-[16px] font-semibold">
                        {editing === 'email' ? (saving ? 'Saving...' : 'Save e-mail') : 'Change e-mail'}
                    </p>
                </button>
            </div>
            <div className="flex flex-col">
                <p className="text-white text-[28px] font-semibold">SMS</p>
                {editing === 'phone' ? (
                    <input
                        className="mt-2 bg-[#141414] border border-[#2C2C2C] rounded-lg text-white px-3 py-2"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                    />
                ) : (
                    <p className="text-gray1 text-[18px] font-normal">{phone || '—'}</p>
                )}
                <button
                    className="flex px-[15px] w-[230px] py-[10px] mt-8 justify-center items-center gap-2 bg-primary rounded-[56px]"
                    onClick={() => editing === 'phone' ? save('phone') : setEditing('phone')}
                    disabled={!isConnected || saving}
                >
                    <img src={PhoneIcon} alt='ico' />
                    <p className="text-black text-[16px] font-semibold">
                        {editing === 'phone' ? (saving ? 'Saving...' : 'Save phone') : 'Change phone number'}
                    </p>
                </button>
                {message && <p className="text-[#FBBF04] text-sm mt-3">{message}</p>}
            </div>
        </div>
    )
}
